module.exports = __webpack_public_path__ + "static/img/smartControl11.9bc5af82.png";